import {observer} from "mobx-react";
import React, {useState} from "react";
import ModalDeleteMessage from "@dropDesk/presentation/components/modals/modal_information";
import ModalMain from "@dropDesk/presentation/components/modals/modal_main";
import EditMessage from "@dropDesk/presentation/components/messages/message_box/arrow_menu_popover/modals/edit_message";
import MessageData from "@dropDesk/presentation/components/messages/message_box/arrow_menu_popover/modals/message_data";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {ChatMessageEntity} from "@dropDesk/domain/entities/messages/message_enums";


const ModalsArrowMenuPopover = observer((
    {
        userClient,
        handleDeleteMessage,
        handleEditMessage,
        setVisibleModalEditMessage,
        visibleModalEditMessage,
        visibleModalDeleteMessage,
        setVisibleModalDeleteMessage,
        visibleModalMessageData,
        setVisibleModalMessageData,
        attendant,
        userLogged,
    }: {
        userClient: UserEntity | null
        attendant?: UserEntity,
        userLogged: UserEntity
        handleDeleteMessage: (message: ChatMessageEntity) => void
        handleEditMessage: (editText: string, currentMessage: ChatMessageEntity) => void
        setVisibleModalEditMessage: React.Dispatch<React.SetStateAction<{
            visible: boolean,
            message: ChatMessageEntity | null
        }>>
        visibleModalEditMessage: { visible: boolean, message: ChatMessageEntity | null }
        visibleModalDeleteMessage: { visible: boolean, message: ChatMessageEntity | null }
        setVisibleModalDeleteMessage: React.Dispatch<React.SetStateAction<{
            visible: boolean,
            message: ChatMessageEntity | null
        }>>
        visibleModalMessageData: { visible: boolean, message: ChatMessageEntity | null }
        setVisibleModalMessageData: React.Dispatch<React.SetStateAction<{
            visible: boolean,
            message: ChatMessageEntity | null
        }>>
    }) => {


    return (
        <>
            <ModalDeleteMessage
                open={visibleModalDeleteMessage.visible}
                onRequestClose={() => {
                    setVisibleModalDeleteMessage({visible: false, message: null});
                }}
                textHeaderModal={'Excluir Mensagem'}
                textButton={'Excluir'}
                onRequestSave={() => {
                    handleDeleteMessage(visibleModalDeleteMessage.message!);
                    setVisibleModalDeleteMessage({visible: false, message: null});
                }}
                nameIcon={ICONS_DROPDESK.delete}
                sizeIcon={130}
                textInformation={
                    `Deseja realmente excluir esta mensagem?`
                }
                loading={false}
                isActionDelete={true}
            />


            {visibleModalEditMessage.message &&
                <ModalMain
                    open={visibleModalEditMessage.visible}
                    onRequestClose={() => setVisibleModalEditMessage({visible: false, message: null})}
                    width={600}
                    renderComponent={
                        <EditMessage
                            message={visibleModalEditMessage.message}
                            onClose={() => setVisibleModalEditMessage({visible: false, message: null})}
                            onSend={(editText: string, currentMessage: ChatMessageEntity) => {
                                handleEditMessage(editText, currentMessage);
                                setVisibleModalEditMessage({visible: false, message: null});
                            }}
                            userClient={userClient}
                            attendant={attendant}
                            userLogged={userLogged}
                        />}
                />
            }

            {visibleModalMessageData.message &&
                <ModalMain
                    open={visibleModalMessageData.visible}
                    onRequestClose={() => setVisibleModalMessageData({visible: false, message: null})}
                    width={600}
                    renderComponent={
                        <MessageData
                            message={visibleModalMessageData.message}
                            onClose={() => setVisibleModalMessageData({visible: false, message: null})}
                            userClient={userClient}
                            attendant={attendant}
                            userLogged={userLogged}
                        />}
                />
            }
        </>

    )
});
export default ModalsArrowMenuPopover;
